/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */

import { useRef, useMemo, useCallback, useContext, useEffect, useState } from 'react';
import get from 'transmute/get';
import ReactDOM from 'react-dom';
import throttle from 'hs-lodash/throttle';
import onboardingContext from 'content-assistance-lib/contexts/onboardingContext';
import ProsemirrorEditor from 'hubspot-prosemirror/prosemirror/ProsemirrorEditor';
import { convertToHtml, convertToPlaintext, getEditorStateFromHtml, focusEditor } from 'hubspot-prosemirror/prosemirror/ProsemirrorUtils';
import styled from 'styled-components';
import hubHttpClient from 'hub-http/clients/apiClient';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import SnippetsApi from 'customer-data-rte/config/SnippetsApi';
import useHubSpotRTE from 'hubspot-prosemirror/prosemirror/useHubSpotRTE';
import { AT_MENTIONS, INSERT_CORE, RICH_TEXT, PLAIN_TEXT, CONTENT_ASSISTANT_SLASH_COMMAND } from 'conversations-thread-data/channel-configuration/public/constants';
import { BOLD, GLOBAL_VARS, ITALIC } from 'hubspot-prosemirror/prosemirror/editorCapabilities';
import { isProsemirrorState } from '../operators/isProsemirror';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import PublishButton from '../plugins/PublishButton';
import usePrevious from 'react-utils/hooks/usePrevious';
import { getPlaceholderPlugin } from 'hubspot-prosemirror/prosemirror/plugins/PlaceholderPlugin';
import { configureMentionsPlugin } from '../plugins/mentionsPlugin';
import { configureSnippetsPlugin } from '../plugins/snippetsPlugin';
import { convertInboxConfigToProsemirror } from '../operators/convertInboxConfigToProsemirror';
import { getPlaceholderText } from '../../../editor-utilities/protected/utils';
import { Metrics } from '../../../metrics/protected/Metrics';
import { useContentAssistanceSettings } from 'conversations-thread-data/content-assistance/public/hooks/useContentAssistanceSettings';
import { useShouldAutoFocusEditor } from '../hooks/useShouldAutoFocusEditor';
import { mergeProsemirrorConfigs } from '../operators/mergeProsemirrorConfigs';
import { EditorTrackerContext } from '../../../usage-tracking/context/EditorTrackerContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const prosemirrorMenuClassName = 'ProsemirrorMenu__inbox';
export const prosemirrorInputClassName = 'ProsemirrorInbox__inbox';
const ProsemirrorStyledEditor = styled.div.withConfig({
  displayName: "ProsemirrorRichTextEditor__ProsemirrorStyledEditor",
  componentId: "iyipiy-0"
})(["flex-grow:1;position:relative;display:flex;flex-direction:column;align-items:stretch;"]);
function ProsemirrorRichTextEditor({
  renderTray: attachmentTray,
  renderSubmitButton,
  disableSubmitMessage,
  disabledAwaitingUserAction,
  onSubmit,
  className,
  setEditorState: onStateChange,
  capabilitiesConfig,
  handleAttachmentChange,
  fileUploadsInProgCount,
  shouldDisableSubmit,
  uploadFile,
  prosemirrorConfig,
  placeholder,
  attachments,
  uploadDroppedFiles,
  editorState: initialEditorState,
  auth,
  onTyping,
  onInsert,
  __typingThrottleInMs = 3000,
  disabledConfig,
  internalEditorStateSetterRef,
  plugins,
  initialHtml
}) {
  const {
    shouldShowAIOnboardingPopover,
    setHasSeenAIOnboardingPopover
  } = useContext(onboardingContext);
  const {
    trackEvent
  } = useContext(EditorTrackerContext);
  const autoFocusOnMount = useShouldAutoFocusEditor();
  const editorRef = useRef(null);
  const lastTypeTime = useRef(null);
  const submitButtonRef = useRef(null);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'customerAnalysisEnabled' does not exist ... Remove this comment to see the full error message
  const {
    customerAnalysisEnabled,
    contentAssistanceEnabled
  } = useContentAssistanceSettings();
  const owners = useMemo(() => {
    var _capabilitiesConfig$A;
    return ((_capabilitiesConfig$A = capabilitiesConfig[AT_MENTIONS]) === null || _capabilitiesConfig$A === void 0 ? void 0 : _capabilitiesConfig$A.users) || [];
  }, [capabilitiesConfig]);
  const prevOwners = usePrevious(owners);
  const usePlaintextMode = !!capabilitiesConfig[PLAIN_TEXT] || get('usePlaintextMode', prosemirrorConfig[GLOBAL_VARS]);
  const inboxConfigAllowsBasicFormatting = capabilitiesConfig[RICH_TEXT] && !capabilitiesConfig[RICH_TEXT].formatStyles;
  const prosemirrorConfigAllowsBasicFormatting = prosemirrorConfig[BOLD] && prosemirrorConfig[ITALIC];
  const allowBasicFormatting = inboxConfigAllowsBasicFormatting || prosemirrorConfigAllowsBasicFormatting;
  const snippetProps = useMemo(() => capabilitiesConfig[INSERT_CORE] ? {
    snippetFunctions: SnippetsApi(hubHttpClient),
    contactEmail: capabilitiesConfig[INSERT_CORE].contactEmail,
    contactVid: capabilitiesConfig[INSERT_CORE].contactVid,
    supplementalObjects: capabilitiesConfig[INSERT_CORE].supplementalObjects,
    usePlaintextMode,
    plaintextOptions: usePlaintextMode ? {
      allowBasicFormatting
    } : undefined
  } : {}, [capabilitiesConfig, usePlaintextMode, allowBasicFormatting]);
  const [customPluginConfig, setCustomPluginConfig] = useState(() => {
    return Object.assign({
      mentions: configureMentionsPlugin({
        owners
      }),
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ snippetFunctions: any; contact... Remove this comment to see the full error message
      snippets: configureSnippetsPlugin(Object.assign({}, snippetProps))
    }, placeholder ? {
      placeholder: getPlaceholderPlugin(getPlaceholderText(placeholder.props.placeholder, !!capabilitiesConfig[CONTENT_ASSISTANT_SLASH_COMMAND]))
    } : {});
  });
  useEffect(() => {
    if (prevOwners && prevOwners.length !== owners.length) {
      setCustomPluginConfig(Object.assign({}, customPluginConfig, {
        mentions: configureMentionsPlugin({
          owners
        })
      }));
    }
  }, [owners, prevOwners, setCustomPluginConfig, customPluginConfig]);
  const prevSnippetProps = usePrevious(snippetProps);
  useEffect(() => {
    if (snippetProps !== prevSnippetProps) {
      setCustomPluginConfig(Object.assign({}, customPluginConfig, {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ snippetFunctions: any; contact... Remove this comment to see the full error message
        snippets: configureSnippetsPlugin(Object.assign({}, snippetProps))
      }));
    }
  }, [snippetProps, prevSnippetProps, setCustomPluginConfig, customPluginConfig]);
  const customPlugins = useMemo(() => {
    const tempPluginConfig = customPluginConfig;
    if (!capabilitiesConfig[AT_MENTIONS]) {
      // @ts-expect-error ts-migrate(2790) FIXME: The operand of a 'delete' operator must be optiona... Remove this comment to see the full error message
      delete tempPluginConfig.mentions;
    }
    return Object.values(tempPluginConfig).concat(...plugins);
  }, [customPluginConfig, capabilitiesConfig, plugins]);
  const [editorState, setEditorState] = useHubSpotRTE();
  if (internalEditorStateSetterRef) {
    internalEditorStateSetterRef.current = setEditorState;
  }
  useEffect(() => {
    if (initialEditorState && isProsemirrorState(initialEditorState) && autoFocusOnMount) {
      setEditorState(focusEditor(initialEditorState));
      onStateChange(initialEditorState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleTyping = useMemo(() => {
    return throttle(onTyping, __typingThrottleInMs, {
      leading: true,
      trailing: false
    });
  }, [onTyping, __typingThrottleInMs]);
  const handleSubmit = useCallback((e, options = {}) => {
    e.preventDefault();
    e.stopPropagation();
    handleTyping.cancel();
    const plainText = convertToPlaintext(editorState).trim();
    const html = convertToHtml(editorState) || plainText;
    onSubmit({
      html,
      plainText,
      options
    });
    setEditorState(getEditorStateFromHtml(initialHtml));
  }, [handleTyping, editorState, onSubmit, setEditorState, initialHtml]);
  const customSubmitButton = useCallback(() => /*#__PURE__*/_jsx(PublishButton, {
    disableSubmit: shouldDisableSubmit,
    disableSubmitMessage: disableSubmitMessage,
    disabledAwaitingUserAction: disabledAwaitingUserAction,
    onSubmit: handleSubmit,
    buttonRef: submitButtonRef,
    renderSubmitButton: renderSubmitButton
  }), [disableSubmitMessage, disabledAwaitingUserAction, submitButtonRef, handleSubmit, renderSubmitButton, shouldDisableSubmit]);
  const prosemirrorConfigFromInboxConfig = useMemo(() => {
    return convertInboxConfigToProsemirror({
      capabilitiesConfig,
      handleAttachmentChange,
      submitButtonRef,
      uploadFile,
      attachments,
      fileUploadsInProgCount,
      uploadDroppedFiles,
      auth,
      onInsert,
      customerAnalysisEnabled,
      contentAssistanceEnabled,
      shouldShowAIOnboardingPopover,
      setHasSeenAIOnboardingPopover,
      trackEvent
    });
  }, [capabilitiesConfig, handleAttachmentChange, uploadFile, attachments, fileUploadsInProgCount, uploadDroppedFiles, auth, onInsert, customerAnalysisEnabled, contentAssistanceEnabled, shouldShowAIOnboardingPopover, setHasSeenAIOnboardingPopover, trackEvent]);
  const editorConfig = useMemo(() => mergeProsemirrorConfigs(prosemirrorConfigFromInboxConfig, prosemirrorConfig), [prosemirrorConfig, prosemirrorConfigFromInboxConfig]);
  useEffect(() => {
    if (editorRef && editorRef.current) {
      const editorEl = ReactDOM.findDOMNode(editorRef.current);
      const editorContentElement = editorEl.querySelector('.ProseMirror');
      editorContentElement.addEventListener('textInput', evt => {
        const latinCharsAndWhiteSpace = /^[-@./#&+\w\s\u00C0-\u00FF]*$/;
        if (lastTypeTime.current === null && latinCharsAndWhiteSpace.test(evt.data)) {
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'null'.
          lastTypeTime.current = performance.now();
        }
      });
      const deactivateIME = () => lastTypeTime.current = null;
      editorContentElement.addEventListener('compositionstart', deactivateIME);
      editorContentElement.addEventListener('compositionupdate', deactivateIME);
      editorContentElement.addEventListener('compositionend', deactivateIME);
    }
  }, []);
  const handleEditorStateChange = useCallback(newEditorState => {
    if (lastTypeTime.current !== null) {
      Metrics.timer('prosemirror-reaction-time').update(performance.now() - lastTypeTime.current);
      lastTypeTime.current = null;
    }
    setEditorState(newEditorState);
    onStateChange(newEditorState);
    if (!editorState.doc.eq(newEditorState.doc)) {
      handleTyping();
    }
  }, [onStateChange, editorState, setEditorState, handleTyping]);
  return /*#__PURE__*/_jsx(ProsemirrorStyledEditor, {
    ref: editorRef,
    className: `${className} ProsemirrorStyledEditor selenium-test-marker-composer`,
    children: /*#__PURE__*/_jsx(ProsemirrorEditor, {
      auth: auth,
      editorConfig: editorConfig,
      editorState: editorState,
      setEditorState: handleEditorStateChange,
      autoFocus: autoFocusOnMount,
      customPlugins: customPlugins,
      menuClassName: prosemirrorMenuClassName,
      inputClassName: prosemirrorInputClassName,
      attachmentTray: attachmentTray,
      submitButton: customSubmitButton,
      performanceTrackingConfig: {
        instanceKey: `Inbox-Reply-Editor`
      },
      disabledConfig: disabledConfig
    })
  });
}
ProsemirrorRichTextEditor.displayName = 'ProsemirrorRichTextEditor';
export default ProsemirrorRichTextEditor;